import { TaskTitleControllerApi } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 *
 * @author [Rajkumar Rathod]
 */
interface Params {
  taskTitle: string;
  xTENANTID?: string;
}

export const useAddTaskTitle = () =>
  useMutationWithLoading(async (params: Params) =>
    new TaskTitleControllerApi(getConfigObject()).createTaskTitle(
      {
        name: params.taskTitle,
      },
      params.xTENANTID
    )
  );
